import { useGetReportUrlQuery } from '../../redux/api/reportBuilderApi'
import { ReportBuilderRequest } from '../../models/ReportBuilder'
import { useContext } from 'react'
import { AuthContext } from '../../common/Auth'

export function useReportUrlWithToken(params: ReportBuilderRequest) {
  const {storeDetails} : any = useContext(AuthContext);
  const reportUrlRequest = {
    ...params,
    accountId: storeDetails?.accountId ?? '',
    contactId:storeDetails?.contactId ?? '',
    storeUrl:storeDetails?.storeurl
  };
  const { data: reportUrlData } = useGetReportUrlQuery(reportUrlRequest)
  return {
    reportUrl: reportUrlData?.data?.url,
  }
}